import { boolean, InferType, object, ObjectSchema, string } from "yup";
import { EditarClienteContract } from "../contracts/editar-empresa.contract";

export const editarClienteSchema: ObjectSchema<EditarClienteContract> = object({
    fantasyName: string()
        .nullable()
        .default(null)
        .when("cnpj", {
            is: (cnpj: string) => !!cnpj && cnpj.trim() !== "",
            then: (schema) => schema.required("Nome Fantasia é obrigatório"),
            otherwise: (schema) => schema.notRequired(),
        }),
    corporateName: string()
        .nullable()
        .default(null)
        .when("cnpj", {
            is: (cnpj: string) => !!cnpj && cnpj.trim() !== "",
            then: (schema) => schema.required("Razão Social é obrigatória"),
            otherwise: (schema) => schema.notRequired(),
        }),
    fullName: string()
        .nullable()
        .default(null)
        .when("cpf", {
            is: (cpf: string) => !!cpf && cpf.trim() !== "",
            then: (schema) => schema.required("O nome da empresa é obrigatória"),
            otherwise: (schema) => schema.notRequired(),
        }),
    email: string().email("E-mail inválido").required("E-mail é obrigatório"),
    cnpj: string().default(""),
    cpf: string().default(""),
    contact1: string().required("Contato é obrigatório"),
    contact2: string().default(""),
    active: boolean().required(),
    address: object().shape({
        zipCode: string().required("CEP é obrigatório"),
        street: string().required("Rua é obrigatória"),
        number: string().required("Número é obrigatório"),
        neighborhood: string().required("Bairro é obrigatório"),
        city: string().required("Cidade é obrigatória"),
        state: string().required("Estado é obrigatório"),
        complement: string().default(""),
    }),
});

export type EditarClienteFormData = InferType<typeof editarClienteSchema>;